import React from "react";
import { Helmet } from "react-helmet-async";

const SOLUTIONS = [
  ["AI Daily Report Management Information System (DRMIS)", "/solutions/ai-drmis/"],
  ["AI Stores Management", "/solutions/ai-stores-management/"],
  ["AI Supplier Identification", "/solutions/ai-supplier-identification/"],
  ["Logistics Gate Automation", "/solutions/logistics-gate-automation/"],
  ["AI for SCADA Analytics", "/solutions/ai-scada-analytics/"],
  ["Supply Chain Portal", "/solutions/supply-chain-portal/"]
];

const SERVICES = [
  ["Agentic AI", "/agentic-ai"],
  ["Robotic Process Automation", "/robotic-process-automation"],
  ["Artificial Intelligence", "/ai"],
  ["Industry 4.0", "/industry-4.0"],
  ["Quality Assurance", "/quality-assurance"]
];

function LinkList({ items }) {
  return (
    <ul className="si-links">
      {items.map(([label, href]) => (
        <li key={href}>
          <a href={href}>{label}</a>
        </li>
      ))}
    </ul>
  );
}

export default function AboutPage() {
  const openAssessment = () => {
    if (typeof window.openAssessmentModal === "function") {
      window.openAssessmentModal("About page");
    } else {
      window.location.href = "/#cta";
    }
  };

  return (
    <>
      <Helmet>
        <title>About Us | SurensInffotek</title>
        <meta
          name="description"
          content="SurensInffotek is a manufacturing-first AI and automation specialist. We give time back to manufacturing leaders and engineers by letting AI handle the routine."
        />
        <link rel="canonical" href="https://surensinffotek.com/about/" />
      </Helmet>
      <main className="si-page">
        <header className="si-intro">
          <div className="si-wrap si-split">
            <div>
              <h1 className="si-title">About <span>SurensInffotek</span></h1>
              <p className="si-lead">
                We are a manufacturing-first AI and automation company. Our job is to take the
                routine work off your plant and office teams, so engineers and managers can spend
                their time on the decisions that matter.
              </p>
            </div>
            <dl className="si-facts">
              <div>
                <dt>Focus</dt>
                <dd>Manufacturing AI &amp; automation</dd>
              </div>
              <div>
                <dt>Offices &amp; markets</dt>
                <dd>Hyderabad (India) · UAE · USA</dd>
              </div>
              <div>
                <dt>Email</dt>
                <dd><a href="mailto:contact@surensinffotek.com">contact@SurensInffotek.com</a></dd>
              </div>
            </dl>
          </div>
        </header>

        <div className="si-wrap">
          <section className="si-section">
            <h2 className="si-h2">Who we are</h2>
            <div>
              <p>
                SurensInffotek works with automotive, auto-component, precision engineering, cable
                and process manufacturers. We start from the problems on the shop floor and in the
                office, not from the technology.
              </p>
              <p>
                Most of our projects replace paper, Excel and manual reporting with AI agents and
                automated workflows that plug into the systems you already run, such as ERP, SCADA
                and quality tools.
              </p>
            </div>
          </section>

          <section className="si-section">
            <h2 className="si-h2">What we offer</h2>
            <div className="si-columns">
              <div>
                <h3 className="si-col-title">Solutions</h3>
                <LinkList items={SOLUTIONS} />
              </div>
              <div>
                <h3 className="si-col-title">Services</h3>
                <LinkList items={SERVICES} />
              </div>
            </div>
          </section>

          <section className="si-contact">
            <div>
              <strong>Want to see where AI fits in your plant?</strong>
              <p>
                Book an assessment or write to{" "}
                <a href="mailto:contact@surensinffotek.com">contact@SurensInffotek.com</a>.
              </p>
            </div>
            <button type="button" className="si-btn" onClick={openAssessment}>
              Book an Assessment
            </button>
          </section>
        </div>
      </main>
    </>
  );
}
